import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';

const StyledCard = styled(Card)`
  height: 100%;
`;

const ActionArea = styled(CardActionArea)`
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
`;

const Cover = styled('div')`
  aspect-ratio: 16 / 9;

  background-color: #f2f2f2;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ${({ src }) => src && `background-image: url(${src});`}
`;

const Name = styled('div')`
  font-weight: 600;
  margin-bottom: 0.25rem;
`;

const Description = styled('div')`
  color: #666;
  font-size: 0.9rem;
  white-space: pre-line;
`;

const PreviewEntryCard = ({ entry, onClick }) => (
  <StyledCard variant="outlined">
    <ActionArea onClick={onClick}>
      <Cover src={entry?.coverEffective?.src} />
      <CardContent>
        <Name>{entry?.name}</Name>
        {entry?.description && <Description>{entry.description}</Description>}
      </CardContent>
    </ActionArea>
  </StyledCard>
);

PreviewEntryCard.propTypes = {
  entry: PropTypes.object,
  onClick: PropTypes.func,
};

export default PreviewEntryCard;
